






































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes, NumberPresetTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import AdminInvoiceCreateButton from '@/modules/invoice/components/admin/AdminInvoiceCreateButton.vue'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import AdminDepositCreateButton from '@/modules/deposit/components/admin/AdminDepositCreateButton.vue'
import {
  DepositCollectionTypeInAdmin,
  DepositCollectionWithModelInAdmin
} from '@/modules/deposit/models/deposit-collection.model'
import AdminDepositTableRow from '@/modules/deposit/components/admin/table/AdminDepositTableRow.vue'
import { getDepositColumnsInAdmin } from '@/modules/deposit/models/columns/deposit-table.column'
import ToolbarDialogButton from '@/modules/shared/components/shared/utils/ToolbarDialogButton.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست واریزی ها'
  },
  metaInfo: {
    title: 'لیست واریزی ها'
  },
  components: {
    ToolbarDialogButton,
    AdminDepositCreateButton,
    AdminInvoiceCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  @Prop() deposits: DepositCollectionTypeInAdmin
  private rowComponent = AdminDepositTableRow
  private columns = getDepositColumnsInAdmin()

  @ProvideReactive()
  get depositsWithData(): DepositCollectionWithModelInAdmin {
    return {
      roles: this.deposits.roles,
      account_types: this.deposits.account_types,
      deposit_bank_accounts: this.deposits.deposit_bank_accounts,
      payable_types: this.deposits.payable_types,
      statuses: this.deposits.statuses,
      settlement_types: this.deposits.settlement_types
    }
  }

  private filters = [
    new Filter({
      type: FilterTypes.Select,
      title: 'وضعیت',
      key: 'status',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.deposits.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع آیتم واریزی',
      key: 'payable_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.deposits.payable_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع حساب واریزی',
      key: 'account_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.deposits.account_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع تصفیه',
      key: 'settlement_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.deposits.settlement_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Toggle,
      title: 'نمایش پنهان شده ها',
      key: 'show_hidden',
      holder: 'انتخاب کنید',
      typeMode: false
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ],
      title: 'تاریخ ایجاد',
      holder: 'انتخاب کنید',
      keys: {
        from: 'created_at_from',
        to: 'created_at_to'
      }
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ],
      title: 'تاریخ پرداخت',
      holder: 'انتخاب کنید',
      keys: {
        from: 'paid_at_from',
        to: 'paid_at_to'
      }
    }),
    new Filter({
      type: FilterTypes.NumericRange,
      title: 'مقدار',
      keys: {
        from: 'amount_gt',
        to: 'amount_lt'
      },
      min: 0,
      max: Infinity,
      presets: [
        NumberPresetTypes.lessThan,
        NumberPresetTypes.greaterThan,
        NumberPresetTypes.equals,
        NumberPresetTypes.range
      ]
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع نقش',
      key: 'role',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: this.deposits.roles
        .map((item, index) => ({
          label: item.nickname,
          value: item.name
        }))
    }),
    new Filter({
      type: FilterTypes.Custom,
      key: 'user',
      title: 'کاربر',
      typeMode: false,
      component: AdminUserSearchFilter
    })
  ]

  protected get model(): any {
    return this.deposits
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
